<template>
  <label  :class="classes">
    <input :type="type" :disabled="proxyDisabled" @input="emitInput">
    <span :class="$style.checkmark"></span>
    <span :class="$style.text"><slot /></span>
  </label>
</template>

<script>
export default {
  name: 'Checkbox',
  props: {
    val: {
      type: [Number, String],
      default: null,
    },
    value: {
      type: [Boolean, Number, String],
      default: null,
    },
    size: {
      type: String, // md || lg
      default: 'md',
    },
    label: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: 'checkbox',
    },
    error: {
      type: Boolean,
      default: false,
    },
    rightAnswer: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    result: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      proxyError: this.error,
      proxyDisabled: this.disabled,
      proxyResult: this.result,
    }
  },
  watch: {
    error() {
      this.proxyError = this.error
    },
    disabled() {
      this.proxyDisabled = this.disabled
    },
    result() {
      this.proxyResult = this.result
    },
  },
  computed: {
    classes() {
      const {
        $style, checked, ok, fail, right, proxyResult, proxyDisabled,
      } = this
      return [
        $style.container,
        checked && $style.checked,
        proxyResult && $style.result,
        fail && $style.fail,
        ok && $style.ok,
        right && $style.right,
        proxyDisabled && $style.disabled,
      ]
    },
    radio() {
      return this.type === 'radio'
    },
    ok() {
      const { proxyResult, rightAnswer, value } = this
      if (!proxyResult) return false

      return rightAnswer && value === rightAnswer
    },
    right() {
      const { proxyResult, rightAnswer, value } = this
      if (!proxyResult) return false

      return rightAnswer && value !== rightAnswer
    },
    fail() {
      const { proxyResult, rightAnswer, value } = this
      if (!proxyResult) return false

      return !rightAnswer && value !== rightAnswer
    },
    checked() {
      const { radio, value, val } = this
      if (!radio) {
        return value
      }
      return val === value
    },
  },
  methods: {
    emitInput() {
      const { value } = this
      if (this.proxyDisabled) { return }
      this.$emit('input', !value)
    },
  },
}
</script>

<style lang="scss" module>
@import './Checkbox.scss';
</style>
